import styled from 'styled-components'
import { Grid } from '../style'
import EmptyComponent from './empty'

export const Layers = styled(Grid)`
    grid-row-gap: 10px;
`

export const List = styled.div`
    grid-column: span 8;
`

export const Empty = styled(EmptyComponent)`
    grid-column: span 8;
`
